document.addEventListener('DOMContentLoaded', function () {

  // Lenis Smooth Scroll
  try {
    var lenis = new Lenis({ duration: 1.2, easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); }, smoothWheel: true });
    function raf(time) { lenis.raf(time); requestAnimationFrame(raf); }
    requestAnimationFrame(raf);
  } catch (e) {}

  // #16 — Scroll Progress Bar
  var progress = document.querySelector('.f5-progress');
  if (progress) {
    window.addEventListener('scroll', function () {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      progress.style.width = (window.scrollY / h * 100) + '%';
    }, { passive: true });
  }

  // #14 — Page Transitions
  var trans = document.querySelector('.f5-page-transition');
  if (trans) {
    document.querySelectorAll('a[href]').forEach(function (a) {
      if (a.hostname === location.hostname && !a.hash && a.target !== '_blank') {
        a.addEventListener('click', function (e) {
          var href = a.href;
          e.preventDefault();
          trans.classList.add('active');
          setTimeout(function () { location.href = href; }, 300);
        });
      }
    });
  }

  // GSAP Animations
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
    gsap.registerPlugin(ScrollTrigger);

    gsap.from('.f5-hero__line', { y: 80, opacity: 0, duration: 1, stagger: 0.15, ease: 'power4.out', delay: 0.3 });
    gsap.from('.f5-hero__badge', { y: 20, opacity: 0, duration: 0.8, delay: 0.1, ease: 'power3.out' });
    gsap.from('.f5-hero__sub', { y: 30, opacity: 0, duration: 0.8, delay: 0.6, ease: 'power3.out' });
    gsap.from('.f5-hero__actions', { y: 30, opacity: 0, duration: 0.8, delay: 0.8, ease: 'power3.out' });
    gsap.from('.f5-hero__visual', { scale: 0.8, opacity: 0, duration: 1.2, delay: 0.4, ease: 'power3.out' });
    gsap.to('.f5-hero__bg-text', { x: -200, scrollTrigger: { trigger: '.f5-hero', start: 'top top', end: 'bottom top', scrub: 1 } });

    // #7 — Sticker parallax
    document.querySelectorAll('.f5-sticker').forEach(function (s) {
      gsap.to(s, { y: -40, rotation: '+=5', scrollTrigger: { trigger: s.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1 } });
    });

    // Section reveals
    ['.f5-what__left','.f5-what__right','.f5-products__header','.f5-howto__inner','.f5-testimonials__inner','.f5-closing-cta__inner','.f5-compare__inner'].forEach(function (s) {
      if (!document.querySelector(s)) return;
      gsap.from(s, { y: 60, opacity: 0, duration: 1, ease: 'power3.out', scrollTrigger: { trigger: s, start: 'top 85%' } });
    });

    if (document.querySelector('.f5-pcard')) {
      gsap.from('.f5-pcard', { y: 80, opacity: 0, duration: 0.8, stagger: 0.15, ease: 'power3.out', scrollTrigger: { trigger: '.f5-products__grid', start: 'top 80%' } });
    }
    if (document.querySelector('.f5-howto__card')) {
      gsap.from('.f5-howto__card', { y: 60, opacity: 0, duration: 0.8, stagger: 0.12, ease: 'power3.out', scrollTrigger: { trigger: '.f5-howto__cards', start: 'top 80%' } });
    }
    if (document.querySelector('.f5-feature-chip')) {
      gsap.from('.f5-feature-chip', { scale: 0.8, opacity: 0, duration: 0.5, stagger: 0.08, ease: 'back.out(1.7)', scrollTrigger: { trigger: '.f5-features-strip', start: 'top 85%' } });
    }
    if (document.querySelector('.f5-tcard')) {
      gsap.from('.f5-tcard', { y: 40, opacity: 0, rotation: 3, duration: 0.7, stagger: 0.1, ease: 'power3.out', scrollTrigger: { trigger: '.f5-testimonials__scroll', start: 'top 85%' } });
    }
    if (document.querySelector('.f5-trust__item')) {
      gsap.from('.f5-trust__item', { y: 20, opacity: 0, duration: 0.5, stagger: 0.08, ease: 'power3.out', scrollTrigger: { trigger: '.f5-trust', start: 'top 90%' } });
    }

    // #2 — Number Counter
    document.querySelectorAll('.f5-stats__num').forEach(function (el) {
      var target = parseInt(el.getAttribute('data-target')) || 0;
      var suffix = el.getAttribute('data-suffix') || '';
      var prefix = el.getAttribute('data-prefix') || '';
      var obj = { val: 0 };
      gsap.to(obj, {
        val: target, duration: 2, ease: 'power2.out',
        scrollTrigger: { trigger: el, start: 'top 85%' },
        onUpdate: function () { el.textContent = prefix + Math.round(obj.val).toLocaleString() + suffix; }
      });
    });
  }

  // 3D Tilt on Product Cards
  document.querySelectorAll('.f5-pcard').forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var r = card.getBoundingClientRect();
      var rx = (e.clientY - r.top - r.height / 2) / 20;
      var ry = (r.width / 2 - (e.clientX - r.left)) / 20;
      card.style.transform = 'perspective(800px) rotateX(' + (-rx) + 'deg) rotateY(' + ry + 'deg) translateY(-8px) scale(1.02)';
    });
    card.addEventListener('mouseleave', function () { card.style.transform = ''; });
  });

  // Custom Cursor
  var cursor = document.querySelector('.f5-cursor');
  var follow = document.querySelector('.f5-cursor-follow');
  if (cursor && follow && window.innerWidth > 768) {
    var mx = 0, my = 0, cx = 0, cy = 0, fx = 0, fy = 0;
    document.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
    (function anim() {
      cx += (mx - cx) * 0.2; cy += (my - cy) * 0.2;
      fx += (mx - fx) * 0.08; fy += (my - fy) * 0.08;
      cursor.style.transform = 'translate(' + (cx - 6) + 'px,' + (cy - 6) + 'px)';
      follow.style.transform = 'translate(' + (fx - 20) + 'px,' + (fy - 20) + 'px)';
      requestAnimationFrame(anim);
    })();
    document.querySelectorAll('a, button, .f5-pcard, .f5-tcard, .f5-pill').forEach(function (el) {
      el.addEventListener('mouseenter', function () { cursor.classList.add('hover'); follow.classList.add('hover'); });
      el.addEventListener('mouseleave', function () { cursor.classList.remove('hover'); follow.classList.remove('hover'); });
    });
  }

  // Magnetic Buttons
  document.querySelectorAll('.f5-pill').forEach(function (btn) {
    btn.addEventListener('mousemove', function (e) {
      var r = btn.getBoundingClientRect();
      btn.style.transform = 'translate(' + ((e.clientX - r.left - r.width / 2) * 0.15) + 'px,' + ((e.clientY - r.top - r.height / 2) * 0.15) + 'px)';
    });
    btn.addEventListener('mouseleave', function () { btn.style.transform = ''; });
  });

  // Mobile Menu
  var burger = document.querySelector('.f5-burger');
  var mob = document.querySelector('.f5-mobile-menu');
  if (burger && mob) {
    burger.addEventListener('click', function () { mob.classList.toggle('active'); burger.classList.toggle('active'); });
    mob.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { mob.classList.remove('active'); burger.classList.remove('active'); }); });
  }

  // #8 — Sticky ATC Bar (product page)
  var stickyAtc = document.querySelector('.f5-sticky-atc');
  var mainAtc = document.querySelector('#f5-buy-buttons');
  if (stickyAtc && mainAtc) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);

    var stickyBtn = document.querySelector('#f5-sticky-atc-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        mainAtc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  }

  // #9 — Urgency Nudges
  var nudges = document.querySelectorAll('.f5-nudge__item');
  if (nudges.length > 0) {
    var nudgeIdx = 0;
    nudges[0].classList.add('active');
    setInterval(function () {
      nudges[nudgeIdx].classList.remove('active');
      nudgeIdx = (nudgeIdx + 1) % nudges.length;
      nudges[nudgeIdx].classList.add('active');
    }, 3000);
  }

  // #10 — Image Zoom on Hover (targets Dawn's real product gallery)
  var pdpGallery = document.querySelector('media-gallery');
  var zoomLens = document.querySelector('#f5-zoom-lens');
  if (pdpGallery && zoomLens && window.innerWidth > 768) {
    pdpGallery.addEventListener('mousemove', function (e) {
      var activeSlide = pdpGallery.querySelector('.product__media-item.is-active');
      var pdpImg = activeSlide ? activeSlide.querySelector('img') : null;
      if (!pdpImg) { zoomLens.style.display = 'none'; return; }
      var r = activeSlide.getBoundingClientRect();
      var x = e.clientX - r.left;
      var y = e.clientY - r.top;
      if (x < 0 || y < 0 || x > r.width || y > r.height) { zoomLens.style.display = 'none'; return; }
      zoomLens.style.display = 'block';
      zoomLens.style.left = (r.left + x - 75) + 'px';
      zoomLens.style.top = (r.top + y - 75) + 'px';
      zoomLens.style.backgroundImage = 'url(' + pdpImg.src + ')';
      zoomLens.style.backgroundSize = (r.width * 2.5) + 'px ' + (r.height * 2.5) + 'px';
      zoomLens.style.backgroundPosition = (-x * 2.5 + 75) + 'px ' + (-y * 2.5 + 75) + 'px';
    });
    pdpGallery.addEventListener('mouseleave', function () { zoomLens.style.display = 'none'; });
  }

  // #19 — Dark Mode Toggle
  var dmToggle = document.querySelector('.f5-darkmode-toggle');
  if (dmToggle) {
    var isDark = localStorage.getItem('f5-dark') === '1';
    if (isDark) document.body.classList.add('f5-dark');
    dmToggle.textContent = isDark ? '☀️' : '🌙';
    dmToggle.addEventListener('click', function () {
      document.body.classList.toggle('f5-dark');
      var dark = document.body.classList.contains('f5-dark');
      localStorage.setItem('f5-dark', dark ? '1' : '0');
      dmToggle.textContent = dark ? '☀️' : '🌙';
    });
  }

  // #20 — ATC Fly Animation
  document.querySelectorAll('.f5-pdp__atc, .f5-sticky-atc .f5-pill').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var img = document.querySelector('.f5-pdp__main img') || document.querySelector('.f5-pcard--active img');
      var cart = document.querySelector('.f5-header__cart') || document.querySelector('.nav__cart-btn');
      if (!img || !cart) return;
      var imgR = img.getBoundingClientRect();
      var cartR = cart.getBoundingClientRect();
      var fly = document.createElement('img');
      fly.src = img.src;
      fly.className = 'f5-fly-img';
      fly.style.left = imgR.left + 'px';
      fly.style.top = imgR.top + 'px';
      fly.style.width = '60px';
      fly.style.height = '60px';
      document.body.appendChild(fly);
      requestAnimationFrame(function () {
        fly.style.left = cartR.left + 'px';
        fly.style.top = cartR.top + 'px';
        fly.style.width = '20px';
        fly.style.height = '20px';
        fly.style.opacity = '0';
      });
      setTimeout(function () { fly.remove(); }, 800);
    });
  });

  // #21 — Easter Egg (click logo 5 times)
  var logoClicks = 0;
  var logo = document.querySelector('.f5-header__logo') || document.querySelector('.nav__logo');
  if (logo) {
    logo.addEventListener('click', function (e) {
      logoClicks++;
      if (logoClicks >= 5) {
        logoClicks = 0;
        e.preventDefault();
        var container = document.createElement('div');
        container.className = 'f5-confetti';
        document.body.appendChild(container);
        var colors = ['#FF6B6B', '#C3A6FF', '#7EDDCA', '#FFD93D', '#FFB3BA'];
        for (var i = 0; i < 50; i++) {
          var piece = document.createElement('div');
          piece.className = 'f5-confetti__piece';
          piece.style.left = Math.random() * 100 + '%';
          piece.style.background = colors[Math.floor(Math.random() * colors.length)];
          piece.style.animationDelay = Math.random() * 0.8 + 's';
          piece.style.animationDuration = (1.5 + Math.random()) + 's';
          container.appendChild(piece);
        }
        setTimeout(function () { container.remove(); }, 3000);
      }
    });
  }

  // #3 — Before/After Slider (Pointer Events + pointer capture so the drag
  // stays "pinned" to the handle even if the cursor leaves the box, and
  // native image drag-out never has a chance to kick in)
  var slider = document.querySelector('.f5-compare__slider');
  if (slider) {
    var handle = slider.querySelector('.f5-compare__handle');
    var afterImg = slider.querySelector('.f5-compare__img--after');
    slider.querySelectorAll('img').forEach(function (img) {
      img.setAttribute('draggable', 'false');
      img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });

    function updateSlider(x) {
      var r = slider.getBoundingClientRect();
      var pct = Math.max(0, Math.min(100, (x - r.left) / r.width * 100));
      handle.style.left = pct + '%';
      afterImg.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
    }

    var dragging = false;
    slider.addEventListener('pointerdown', function (e) {
      dragging = true;
      slider.setPointerCapture(e.pointerId);
      updateSlider(e.clientX);
      e.preventDefault();
    });
    slider.addEventListener('pointermove', function (e) { if (dragging) updateSlider(e.clientX); });
    slider.addEventListener('pointerup', function (e) {
      dragging = false;
      slider.releasePointerCapture(e.pointerId);
    });
    slider.addEventListener('pointercancel', function () { dragging = false; });
  }

  // Social Proof — each card auto-crossfades between before/after via a CSS
  // animation (runs immediately, no scroll-wait or click needed). Clicking
  // a card just pauses/resumes that animation.
  document.querySelectorAll('.f5-social__card').forEach(function (card) {
    card.querySelector('.f5-social__pause').addEventListener('click', function (e) {
      e.stopPropagation();
      card.classList.toggle('f5-paused');
    });
  });
  if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined' && document.querySelector('.f5-social__card')) {
    gsap.from('.f5-social__card', { y: 60, opacity: 0, duration: 0.8, stagger: 0.1, ease: 'power3.out', scrollTrigger: { trigger: '.f5-social__grid', start: 'top 82%' } });
  }

  // Review / ranking cards with no article yet open a detail modal populated
  // by cloning that card's matching <template data-review-target> content.
  var reviewModal = document.getElementById('f5ReviewModal');
  if (reviewModal) {
    var modalContent = reviewModal.querySelector('.f5-review-modal__content');
    var modalBody = reviewModal.querySelector('.f5-review-modal__body');
    var modalBox = reviewModal.querySelector('.f5-review-modal__box');
    var lastFocused = null;
    var lockedScrollY = 0;

    function updateScrollAffordance() {
      var scrollable = modalBody.scrollHeight - modalBody.scrollTop - modalBody.clientHeight > 2;
      modalBody.classList.toggle('is-scrollable', scrollable);
    }

    function trapFocus(e) {
      if (e.key !== 'Tab') return;
      var focusable = modalBox.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }

    function openReviewModal(card) {
      var targetId = card.getAttribute('data-review-target');
      var tpl = targetId && document.getElementById(targetId);
      if (!tpl) return;
      lastFocused = document.activeElement;
      modalContent.innerHTML = '';
      modalContent.appendChild(tpl.content.cloneNode(true));
      reviewModal.hidden = false;
      modalBody.scrollTop = 0;
      reviewModal.querySelector('.f5-review-modal__close').focus();
      updateScrollAffordance();

      // Body scroll lock via the position-fixed technique — plain
      // overflow:hidden on <body> still lets iOS scroll behind the modal
      // and loses the page's scroll position.
      lockedScrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + lockedScrollY + 'px';
      document.body.style.width = '100%';
      // Lenis drives scrolling itself (bypassing native overflow:hidden), so
      // it has to be told to stop separately or the background keeps scrolling.
      if (typeof lenis !== 'undefined' && lenis && lenis.stop) lenis.stop();

      modalBody.addEventListener('scroll', updateScrollAffordance);
      document.addEventListener('keydown', trapFocus);
    }

    function closeReviewModal() {
      reviewModal.hidden = true;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY);
      if (typeof lenis !== 'undefined' && lenis && lenis.start) lenis.start();
      modalBody.removeEventListener('scroll', updateScrollAffordance);
      document.removeEventListener('keydown', trapFocus);
      if (lastFocused) lastFocused.focus();
    }

    document.querySelectorAll('[data-f5-review-card]').forEach(function (card) {
      card.addEventListener('click', function () { openReviewModal(card); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openReviewModal(card); }
      });
    });
    reviewModal.querySelectorAll('[data-f5-review-close]').forEach(function (el) {
      el.addEventListener('click', closeReviewModal);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !reviewModal.hidden) closeReviewModal();
    });
  }
});
